import React from 'react';
import { ConfirmDialog } from '../../../../components/confirm-dialog';

interface IDeleteLessonDialogProps {
  isOpen: boolean;
  onConfirmClick: () => void;
  onCancelClick: () => void;
  lessonCount?: number;
  isLoading?: boolean;
}

export function DeleteLessonDialog(props: IDeleteLessonDialogProps) {
  const { isOpen, onConfirmClick, onCancelClick, lessonCount = 1, isLoading } = props;
  const isPlural = lessonCount > 1;
  const title = isPlural ? 'Slet lektioner?' : 'Slet lektion?';
  const confirmButtonText = isPlural ? 'Ja, slet lektioner' : 'Ja, slet lektion';
  return (
    <ConfirmDialog
      type="question"
      title={title}
      onConfirmClick={onConfirmClick}
      open={isOpen || !!isLoading}
      onCancelClick={onCancelClick}
      confirmButtonText={confirmButtonText}
      cancelButtonText="Afbryd"
      cancelIsPrimary={false}
      isLoading={isLoading}
      maxWidth="md"
    >
      {isPlural && <p>Vil du slette de {lessonCount} valgte lektioner?</p>}
    </ConfirmDialog>
  );
}
